// ------------------------------------------------------------
// Constants
//
// TBD
// ------------------------------------------------------------

const CASE_CATEGORIES = {
  CASE_CATEGORY_APPELLATE: 'Appellate',
  CASE_CATEGORY_CIVIL: 'Civil',
  CASE_CATEGORY_CRIMINAL: 'Criminal',
  CASE_CATEGORY_FAMILY: 'Family',
  CASE_CATEGORY_TRAFFIC: 'Traffic'
};

export default {
  // TODO we should update HeaderResponseDTO to include the ID property as well so we don't need these string constants
  // and can just use the ID constants below
  DISPLAY_TYPE_BOOLEAN: 'Boolean',
  DISPLAY_TYPE_DATE: 'Date',
  DISPLAY_TYPE_DATETIME: 'Datetime',
  DISPLAY_TYPE_DECIMAL: 'Decimal',
  DISPLAY_TYPE_MONEY: 'Money',
  DISPLAY_TYPE_NUMBER: 'Number',
  DISPLAY_TYPE_PERCENT: 'Percent',
  DISPLAY_TYPE_STRING: 'String',

  DISPLAY_TYPE_BOOLEAN_ID: 666,
  DISPLAY_TYPE_DATE_ID: 664,
  DISPLAY_TYPE_DATETIME_ID: 665,
  DISPLAY_TYPE_DECIMAL_ID: 694,
  DISPLAY_TYPE_MONEY_ID: 663,
  DISPLAY_TYPE_NUMBER_ID: 693,
  DISPLAY_TYPE_PERCENT_ID: 695,
  DISPLAY_TYPE_STRING_ID: 662,

  SORT_DIRECTION_VALUE_ASC: '150005',
  SORT_DIRECTION_VALUE_DESC: '150006',

  searchTypes: {
    assessment: {
      searchTypeID: 150001, componentID: 150002, icon: 'fas fa-dollar-sign', resourceName: 'assessments'
    },
    calendar: {
      searchTypeID: 150011, componentID: 150017, icon: 'far fa-calendar-alt', resourceName: 'calendars'
    },
    case: {
      searchTypeID: 150000, componentID: 150000, icon: 'fas fa-folder-open', resourceName: 'cases'
    },
    citation: {
      searchTypeID: 150014, componentID: 150018, icon: 'far fa-list-alt', resourceName: 'citations'
    },
    charge: {
      searchTypeID: 150002, componentID: 150003, icon: 'fas fa-list-ol', resourceName: 'charges'
    },
    docketEntry: {
      searchTypeID: 150003, componentID: 150004, icon: 'fas fa-file-alt', resourceName: 'docketentries'
    },
    document: {
      searchTypeID: 150017, componentID: 150019, icon: 'far fa-file-alt', resourceName: 'publicaccessdocuments'
    },
    hearing: {
      searchTypeID: 150004, componentID: 150005, icon: 'far fa-clock', resourceName: 'hearings'
    },
    judgment: {
      searchTypeID: 150005, componentID: 150006, icon: 'fas fa-balance-scale', resourceName: 'judgments'
    },
    lowerCourt: {
      searchTypeID: 150015, componentID: 150015, icon: 'fas fa-university', resourceName: 'lowercourts'
    },
    opinion: {
      searchTypeID: 150018, componentID: 150040, icon: 'fas fa-gavel', resourceName: 'opinions'
    },
    party: {
      searchTypeID: 150006, componentID: 150007, icon: 'fas fa-users', resourceName: 'parties'
    },
    receipt: {
      searchTypeID: 150016, componentID: 150014, icon: 'fas fa-dollar-sign', resourceName: 'receipts'
    },
    warrant: {
      searchTypeID: 150009, componentID: 150010, icon: 'far fa-address-card', resourceName: 'warrants'
    }
  },
  ...CASE_CATEGORIES,
  caseViewTabs: [
    {
      name: 'assessments',
      orderBy: 7,
      componentID: 150029,
      viewID: 150002,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_CIVIL,
        CASE_CATEGORIES.CASE_CATEGORY_CRIMINAL,
        CASE_CATEGORIES.CASE_CATEGORY_FAMILY,
        CASE_CATEGORIES.CASE_CATEGORY_TRAFFIC
      ]
    },
    {
      name: 'citations',
      orderBy: 6,
      componentID: 150031,
      viewID: 150003,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_CRIMINAL,
        CASE_CATEGORIES.CASE_CATEGORY_TRAFFIC
      ]
    },
    {
      name: 'charges',
      orderBy: 5,
      componentID: 150030,
      viewID: 150004,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_CRIMINAL,
        CASE_CATEGORIES.CASE_CATEGORY_TRAFFIC
      ]
    },
    {
      name: 'docketEntries',
      orderBy: 2,
      componentID: 150032,
      viewID: 150005,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_APPELLATE,
        CASE_CATEGORIES.CASE_CATEGORY_CIVIL,
        CASE_CATEGORIES.CASE_CATEGORY_CRIMINAL,
        CASE_CATEGORIES.CASE_CATEGORY_FAMILY,
        CASE_CATEGORIES.CASE_CATEGORY_TRAFFIC
      ]
    },
    {
      name: 'hearings',
      orderBy: 3,
      componentID: 150033,
      viewID: 150006,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_APPELLATE,
        CASE_CATEGORIES.CASE_CATEGORY_CIVIL,
        CASE_CATEGORIES.CASE_CATEGORY_CRIMINAL,
        CASE_CATEGORIES.CASE_CATEGORY_FAMILY,
        CASE_CATEGORIES.CASE_CATEGORY_TRAFFIC
      ]
    },
    {
      name: 'judgments',
      orderBy: 4,
      componentID: 150034,
      viewID: 150007,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_CIVIL
      ]
    },
    {
      name: 'lowerCourts',
      orderBy: 8,
      componentID: 150035,
      viewID: 150008,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_APPELLATE
      ]
    },
    {
      name: 'parties',
      orderBy: 1,
      componentID: 150036,
      viewID: 150001,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_APPELLATE,
        CASE_CATEGORIES.CASE_CATEGORY_CIVIL,
        CASE_CATEGORIES.CASE_CATEGORY_CRIMINAL,
        CASE_CATEGORIES.CASE_CATEGORY_FAMILY,
        CASE_CATEGORIES.CASE_CATEGORY_TRAFFIC
      ]
    },
    {
      name: 'receipts',
      orderBy: 9,
      componentID: 150037,
      viewID: 150009,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_APPELLATE,
        CASE_CATEGORIES.CASE_CATEGORY_CIVIL,
        CASE_CATEGORIES.CASE_CATEGORY_CRIMINAL,
        CASE_CATEGORIES.CASE_CATEGORY_FAMILY,
        CASE_CATEGORIES.CASE_CATEGORY_TRAFFIC
      ]
    },
    {
      name: 'warrants',
      orderBy: 10,
      componentID: 150038,
      viewID: 150010,
      caseCategories: [
        CASE_CATEGORIES.CASE_CATEGORY_CIVIL,
        CASE_CATEGORIES.CASE_CATEGORY_CRIMINAL,
        CASE_CATEGORIES.CASE_CATEGORY_TRAFFIC
      ]
    }
  ],

  getTabByProperty (prop, val) {
    return this.caseViewTabs.filter((tab) => {return tab[prop] === val;})[0];
  },

  getTabsByCategory (category) {
    return this.caseViewTabs.filter((tab) => {return tab.caseCategories.indexOf(category) >= 0;});
  },

  SYSTEM_CODE_TYPE_VIEW_TYPE: 150000,

  ADVANCED_SEARCH_TYPE_STRING: 140013,
  ADVANCED_SEARCH_TYPE_DATE: 140014,
  ADVANCED_SEARCH_TYPE_DATE_RANGE: 140015,

  INDEX_FIELD_TYPE_STRING: 140000,
  INDEX_FIELD_TYPE_NAME: 140004, // phonetic
  INDEX_FIELD_TYPE_ALPHANUMERIC: 140016,
  INDEX_FIELD_TYPE_STRING_TEXT: 140023,

  INDEX_FIELD_ID_DOCUMENT_TEXT: 151306,

  COMPONENT_DOCUMENTS_DOCKET_ENTRY: 150016,
  COMPONENT_STATIC_LINKS: 150039,
  COMPONENT_CASE_VIEW_SUMMARY: 150041,

  PERMISSION_TYPES: {
    READ: 1,
    CREATE: 2,
    EDIT: 4,
    REMOVE: 8,
    ON: 1 | 2 | 4 | 8 // eslint-disable-line no-bitwise
  },

  MAX_SUMMARY_RESULTS_LIMIT: 250 // must be less than or equal to cove MAX_API_RESULTS_LIMIT
};
